<template>
  <div>
    <h1>Operators</h1>
    <v-expansion-panel v-model="panel" expand>
      <v-expansion-panel-content>
        <template v-slot:header>
          <h2>
            <v-icon>search</v-icon>Search operator database
          </h2>
        </template>
        <v-card>
          <v-card-text>
            <v-container fluid grid-list-md>
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-text-field v-model="reference" label="Reference" outline />
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field v-model="surname" label="Surname" outline />
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field v-model="subjectproperty" label="Subject property" outline />
                </v-flex>
              </v-layout>
            </v-container>
            <v-btn @click="searchOperators" :loading="loading">
              <v-icon>search</v-icon>
              <span>&#160;Search</span>
            </v-btn>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <OperatorsZ :operators="operators" :loading="loading" />
  </div>
</template>

<script>
import OperatorsZ from "@/components/operator/Operators";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Operators",
  metaInfo() {
    return {
      title: "Operators",
      titleTemplate: "%s - File - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: { OperatorsZ },
  data() {
    return {
      operators: [],
      reference: "",
      surname: "",
      subjectproperty: "",
      panel: [],
      loading: false
    };
  },
  methods: {
    searchOperators() {
      nbmlaw
        .get(`/cors/admin/file/operators`, {
          params: {
            reference: this.reference,
            surname: this.surname,
            subjectproperty: this.subjectproperty
          }
        })
        .then(response => {
          // console.log(response.data);
          this.operators = response.data;
          this.loading = false;
        });
    }
  }
};
</script>

<style>
</style>
